import { useAuth } from '@ben/shared/providers/auth-provider';
import { useQuery } from '@tanstack/react-query';
import type { ECCUiConfig } from '../../api/ecc/ecc-ui-config';
import { getEccUiConfig } from '../../api/ecc/ecc-ui-config';
import type { TUseQueryOptions } from './use-query-base';
import { createInvalidateHook, useSetQueryBase } from './use-query-base';

const QUERY_KEY = 'employerSideMenu';

const getKey = () => {
  return [QUERY_KEY];
};

export const useQueryEmployerSideMenu = (
  options?: TUseQueryOptions<ECCUiConfig>
) => {
  const { isAuthenticated } = useAuth();
  return useQuery<ECCUiConfig>({
    ...options,
    enabled: isAuthenticated && options?.enabled !== false,
    queryKey: getKey(),
    queryFn: getEccUiConfig,
  });
};

export const useInvalidateEmployerSideMenu = createInvalidateHook(getKey);

export const useSetQueryEmployerSideMenu = () => {
  return useSetQueryBase<undefined, ECCUiConfig>(getKey);
};
